import { AdjustmentsService } from '@/backend/market'
import { AdjustmentRepository } from '../../domain/repositories/AdjustmentRepository'
import { AdjustmentModel } from '../models/AdjustmentModel'
import { AdjustmentMiniModel } from '../models/AdjustmentMiniModel'
import type { AdjustmentMiniEntity } from '../../domain/entities/AdjustmentMiniEntity'
import type { AdjustmentEntity } from '../../domain/entities/AdjustmentEntity'
import type { AdjustmentFilterEntity } from '../../domain/entities/AdjustmentFilterEntity'
import { AdjustmentFilterModel } from '../models/AdjustmentFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import { CreateUpdateAdjustmentModel } from '../models/CreateUpdateAdjustmentModel'
import type { CreateUpdateAdjustmentEntity } from '../../domain/entities/CreateUpdateAdjustmentEntity'

export class AdjustmentRepositoryImpl implements AdjustmentRepository {
  async getAdjustments(
    filters?: AdjustmentFilterEntity
  ): Promise<PaginateEntity<AdjustmentMiniEntity[]> | { error: true }> {
    const adjustmentFilterModel = new AdjustmentFilterModel(filters ?? {})
    try {
      const response = await AdjustmentsService.getAdjustmentsAdmin(adjustmentFilterModel)
      const adjustmentModels = response.items?.map(
        (adjustment) => new AdjustmentMiniModel(adjustment)
      )
      const adjustmentResponse = new PaginateEntity<AdjustmentMiniModel[]>(
        response,
        adjustmentModels
      )

      return adjustmentResponse
    } catch {
      return { error: true }
    }
  }

  async getAdjustmentById(id: number): Promise<AdjustmentEntity | { error: true }> {
    try {
      const response = await AdjustmentsService.getAdjustmentAdmin({
        id
      })
      const adjustmentModel = new AdjustmentModel(response)

      return adjustmentModel
    } catch {
      return { error: true }
    }
  }

  async createAdjustment(
    data: CreateUpdateAdjustmentEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const createUpdateAdjustmentModel = new CreateUpdateAdjustmentModel(data)
      await AdjustmentsService.createAdjustmentAdmin({
        requestBody: createUpdateAdjustmentModel
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateAdjustment(
    id: number,
    data: CreateUpdateAdjustmentEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const createUpdateAdjustmentModel = new CreateUpdateAdjustmentModel(data)
      await AdjustmentsService.updateAdjustmentAdmin({
        id,
        requestBody: createUpdateAdjustmentModel
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteAdjustment(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await AdjustmentsService.deleteAdjustmentAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
